/**
 * Copyright 2017 CA
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *    http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

/* @flow */
export { default } from './palette';
export { default as blue } from './blue';
export { default as common } from './common';
export { default as dusk } from './dusk';
export { default as gray } from './gray';
export { default as green } from './green';
export { default as indigo } from './indigo';
export { default as lime } from './lime';
export { default as magenta } from './magenta';
export { default as orange } from './orange';
export { default as purple } from './purple';
export { default as red } from './red';
export { default as sky } from './sky';
export { default as slate } from './slate';
export { default as teal } from './teal';
export { default as yellow } from './yellow';

export { default as getColor } from './getColor';
export { default as getReadableTextColor } from './getReadableTextColor';



// WEBPACK FOOTER //
// ./src/colors/index.js